import React from 'react'
import { SkeletonButton } from '@offerzen/pinata'
import { cx } from '@emotion/css'
import styles, { borderColor } from './styles'

// eslint-disable-next-line react/prop-types
const SkeletonWorkAuthorisationsAdd = ({ theme }) => (
  <div className={cx(styles.card, borderColor(theme))}>
    <SkeletonButton theme={theme} className={styles.addButton} />
  </div>
)

export default SkeletonWorkAuthorisationsAdd
